import pauseUnpauseMachineRequest from './pause-unpause-machine-request';

const extraReducers = {
  pauseUnpauseMachineRequest,
};

export default extraReducers;
